module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h14"
  }, [_vm._v("A"), _c('span', {
    staticClass: "th14"
  }, [_vm._v("CKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("To the countless storytellers who’ve shown us ")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("how the inner journey gives meaning to the outer;"), _c('span', {
    staticClass: "t5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("to Dr. Grant Johnson for sharing his ")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("expertise in Ericksonian hypnotherapy;")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("to my writing buddies whose insights made ")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("this story so much better, especially")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("Martha Ragland and the rest of ")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("my wonderful “Oregonian” critique circle; ")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("and to my husband Bob, for his loving patience—")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("heartfelt thanks.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }), _vm._v(" "), _c('p', {
    staticClass: "p5"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af0d7b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005.vue
// module id = 66
// module chunks = 0